// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-I":"I_delta-pro-ultra-I__ji91I"};